module.exports = __webpack_public_path__ + "img/shadow-suitcase.baa33584.png";